import React from 'react';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import {featureFlags} from 'utils/const';
import DashboardSidebar from 'components/pure/admin/DashboardSidebar';

const administerChildren = List([
  {
    name: 'Users',
    url: '/admin/users',
  },
  {
    name: 'Welcome Email',
    url: '/admin/welcome-email',
  },
  {
    name: 'Teams',
    url: '/admin/teams',
  },
  {
    name: 'Departments',
    url: '/admin/departments',
  },
]);

const coachingChildren = List([
  {
    name: 'Archiving',
    url: '/admin/archivingProfiles',
    flag: 'admin:archivingProfiles',
  },
  {
    name: 'Scorecard',
    url: '/admin/cardProfiles',
  },
  {
    name: 'Scorecard Reasons',
    url: '/admin/cardReasons',
  },
  {
    name: 'Scorecard Schemes',
    url: '/admin/cardSchemes',
  },
  {
    name: 'Performance Goals & KPIs',
    url: '/admin/kpis',
    flag: featureFlags.adminKpis,
  },
  {
    name: 'Jobs',
    url: `/admin/jobs`,
    flag: featureFlags.adminKpis,
  },
  {
    name: 'Coaching Meeting Types',
    url: '/admin/sessionTypes',
  },
]);

const sidebarMenu = List([
  {
    name: 'Profile',
    url: '/admin/profile',
  },
  {
    name: 'Administer',
    children: administerChildren,
  },
  {
    name: 'Coaching',
    children: coachingChildren,
  },
  {
    name: 'Keywords / Topics',
    url: '/admin/topics',
  },
  {
    name: 'Smart Alerts',
    url: '/admin/actions',
  },
  {
    name: 'Library',
    url: '/admin/libraryManagement',
  },
  {
    name: 'Integrations',
    url: '/admin/integrations',
  },
]);

class AdminSidebar extends React.Component {
  render() {
    return <DashboardSidebar sidebarMenu={sidebarMenu} sidebarOpen={this.props.sidebarOpen} />;
  }
}

AdminSidebar.propTypes = {
  disabledLinks: PropTypes.arrayOf(PropTypes.string),
  sidebarOpen: PropTypes.bool.isRequired,
};

AdminSidebar.defaultProps = {
  disabledLinks: [],
};

AdminSidebar.displayName = 'AdminSidebar';

export default AdminSidebar;
